import { ContextStore } from 'bernie-core';
import { Logger } from 'bernie-logger';

import { bffFetch, Headers } from './bff-fetch';

export class RateCalendarApiSource {
  private host: string;
  private logger: Logger;
  private forwardedHeaders: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetchHIS(context: ContextStore, criteria: any, hotelId: number): Promise<any> {
    if (context && criteria && hotelId && criteria.adults === 2 && !criteria.children) {
      return bffFetch(this.host, `rate-calendar/hotel/${hotelId}`, context, 0, criteria, this.logger, this.forwardedHeaders);
    }

    return Promise.resolve();
  }
}
